
import React from "react";
import "../Styles-css/About.css"; 
import { FaSmile, FaHome, FaUserTie } from "react-icons/fa";
import { FaPaintBrush, FaCouch, FaTree, FaBuilding, FaTools } from "react-icons/fa";

import about_main from "../Image/thumb-slider-img-1.jpg"
import about_img1 from "../Image/thumb-slider-img-2.jpg"
import about_img2 from "../Image/thumb-slider-img-3.jpg"
import about_img3 from "../Image/thumb-slider-img-4.jpg"

import gallery1 from "../Image/gallery-img-1.jpg"
import gallery2 from "../Image/gallery-img-2.jpg"
import gallery3 from "../Image/gallery-img-2.jpg"
import gallery4 from "../Image/gallery-img-3.jpg"
import gallery5 from "../Image/gallery-img-5.jpg"

const features = [
  { id: "01", title: "Easy To Rent", description: "Easy To Rent makes finding your perfect space simple, fast, and hassle-free — from homes to offices and everything in between.", icon: <FaHome /> },
  { id: "02", title: "Carefully Crafted", description: "Carefully crafted spaces designed to match your lifestyle — with comfort, quality, and convenience in every detail.", icon: <FaPaintBrush /> },
  { id: "03", title: "In-built Wardrobe", description: "Maximize your space with elegant in-built wardrobes, offering seamless storage solutions and a clutter-free, organized living experience.", icon: <FaCouch /> },
  { id: "04", title: "Lavish Greenary", description: "Experience serene living surrounded by lavish greenery, offering tranquility, fresh air, and the perfect balance between nature and luxury.", icon: <FaTree /> },
  { id: "05", title: "Spacious Outdoor", description: "Enjoy the freedom of expansive outdoor spaces, perfect for relaxation, recreation, and entertainment.", icon: <FaBuilding /> },
  { id: "06", title: "Planned Construction", description: "Planned construction with precision, ensuring every space is built for durability, functionality, and style.", icon: <FaTools /> },
];


const images = [
  { src: gallery1, alt: "Modern House" },
  { src: gallery2, alt: "Modern Kitchen" },
  { src:gallery5, alt: "Living Room" },
  { src: gallery4, alt: "Dining Room" },
  { src: gallery3, alt: "Bar Area" },
  { src: gallery1, alt: "Bar Area" },

];

const About = () => {   
  return (
    <>
    <section className="about-hero">
      <div className="about-overlay">
        <div className="about-container">
          <p className="about-location">
            📍 3911 Firestone Blvd, South Gate, CA 90280, United States
          </p>
          <h1 className="about-title">About Us – Your Trusted Rental Partner</h1>
          <p className="about-description">
            At Kirayawala, we make renting simple, fast, and hassle-free. Whether you're looking for a home, office, warehouse, or flat, we connect you with the best options tailored to your needs. With verified listings, transparent deals, and dedicated support, we’re here to help you find the perfect space — every time.
          </p>
          <div className="about-buttons">
            <button className="about-btn about-tour">Take A Tour</button>
            <button className="about-btn about-quote">Get A Quote</button>
          </div>
        </div>
      </div>
    </section>
    <section className="living-section">
      <div className="living-container">
        {/* Left Side: Image */}
        <div className="living-image">
          <img src={about_main} alt="Luxury Pool" />
        </div>

        {/* Right Side: Text & Stats */}
        <div className="living-content">
          <p className="living-subtitle">CONTEMPORARY LIVING</p>
          <h2 className="living-title">
            Who We Are
          </h2>
          <p className="living-description">
            Kirayawala started as a simple idea: to make finding a home hassle-free. Over the years, we've grown into a trusted platform that connects tenants and homeowners, creating a vibrant rental ecosystem. With roots in addressing the challenges of urban renters, we've always been about reimagining what home means in today's fast-paced world. Today, we're a complete PropTech solution—offering services for rentals, property management, and buying or selling homes.
          </p>

          {/* Statistics Section */}
          <div className="living-stats">
            <div className="stat">
              <FaSmile className="stat-icon" />
              <p className="stat-value">30K</p>
              <p className="stat-label">Happy Customers</p>
            </div>
            <div className="stat">
              <FaHome className="stat-icon" />
              <p className="stat-value">20K</p>
              <p className="stat-label">Homes Sold</p>
            </div>
            <div className="stat">
              <FaUserTie className="stat-icon" />
              <p className="stat-value">35+</p>
              <p className="stat-label">Agents</p>
            </div>
          </div>

          {/* Image Gallery */}
          <div className="living-gallery">
            <img src={about_img1} alt="House 1" />
            <img src={about_img2} alt="House 2" />
            <img src={about_img3} alt="House 3" />
            <img src={about_main} alt="House 4" />
          </div>
        </div>
      </div>
    </section>

    
    </>
  );
};

export default About;
